define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PastureDensityDomain = void 0;
    class PastureDensityDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: PastureDensityDomain.High, value: "High" },
                    { key: PastureDensityDomain.Moderate, value: "Moderate" },
                    { key: PastureDensityDomain.Low, value: "Low" },
                    { key: PastureDensityDomain.Na, value: "NA" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[PastureDensityDomain.High] = 0;
                this.KeyIndex[PastureDensityDomain.Moderate] = 1;
                this.KeyIndex[PastureDensityDomain.Low] = 2;
                this.KeyIndex[PastureDensityDomain.Na] = 3;
                this.ValueIndex = {};
                this.ValueIndex["High"] = 0;
                this.ValueIndex["Moderate"] = 1;
                this.ValueIndex["Low"] = 2;
                this.ValueIndex["NA"] = 3;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.PastureDensityDomain = PastureDensityDomain;
    Object.defineProperty(PastureDensityDomain, "High", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "H"
    });
    Object.defineProperty(PastureDensityDomain, "Moderate", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "M"
    });
    Object.defineProperty(PastureDensityDomain, "Low", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "L"
    });
    Object.defineProperty(PastureDensityDomain, "Na", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "NA"
    });
    Object.defineProperty(PastureDensityDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
